// extracted by mini-css-extract-plugin
export default {"hidden":"UploadFile_hidden__7q4ou","container":"UploadFile_container__-+1AE","editBtn":"UploadFile_editBtn__nqvn6"};